import {createAction} from "@reduxjs/toolkit";

export const setArchiveEvents = createAction('SET_ARCHIVE_EVENTS');